import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'

export class VerificationWrapper extends Component {
  render() {
    const {
      isAuthenticated,
      component: WrappedComponent,
      otherProps } = this.props

    // Always allow access if authenticated - verification disabled
    if (isAuthenticated) return (<WrappedComponent {...otherProps} />)

    if (!isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: this.props.location }
          }}
        />
      )
    }

    // This should never be reached due to the check above, but keeping as fallback
    return (<WrappedComponent {...otherProps} />)
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  emailVerified: state.auth.currentUser && state.auth.currentUser.emailVerified,
  phoneVerified: state.auth.currentUser && state.auth.currentUser.phoneVerified,
  primaryEmail: state.auth.currentUser && state.auth.currentUser.primaryEmail,
  primaryPhone: state.auth.currentUser && state.auth.currentUser.primaryPhone
})

export default withRouter(connect(mapStateToProps)(VerificationWrapper))
